/* eslint-disable react/prop-types */
import React from 'react';
// components
import { Message } from '@design-system-coopeuch/web';
import Alert from '@coopeuch-components/web/atoms/Alert';
import CardParticipationFees from './CardParticipationFees';
import CardBankAccount from './CardBankAccount';
import CardContracts from './CardContracts';
import CardStatutes from './CardStatutes';
import CardTermsAndConditions from './CardTermsAndConditions';
import CardEletronicSignature from './CardElectronicSignature';
import FlowControlButtons from '../../molecules/FlowControlButtons/FlowControlButtons';
import Survey from '../../../containers/Survey/Survey';

import Modal from '../../organisms/Modal/Modal';
import CaseInfo from '../../molecules/CaseInfo/CaseInfo';

// assets
import { StyledWrapperCards } from './styles';
/* istanbul ignore next */
const ContractsTemplate = (props) => {
  const {
    isMobileDevice,
    visibilityWarningMessage,
    monthlyFees,
    monthlyInvestment,
    participationFeesParams,
    isValidMonthlyFee,
    bank,
    accountType,
    accountNumber,
    banksItems,
    accountsTypesItems,
    contracts,
    termsAndConditions,
    isCompletedCardParticipationFees,
    isCompletedCardBankAccount,
    isCompletedCardTermsAndConditions,
    isOpenModalEdgeCase,
    isOpenModalAbandonmentSurvey,
    closeModalAbandonmentSurvey,
    currentEdgeCase,
    closeModalEdgeCase,
    onChangeField,
    inputCodeSMS,
    phone,
    stateAuthSms,
    messagesInputAuthSms,
    canContinueFlow,
    onDownloadContract,
    onInvokeAuthSms,
    onTimeOverToRespond,
    onContinueFlow,
    onCancelFlow,
    onActionButtonCaseBorder,
    handleChangeCustom,
    validateSignature,
    abono
    /* onCallSurvey, */
  } = props;

  return (
    <StyledWrapperCards>
      {visibilityWarningMessage ? (
        <Message
          className="w-100"
          type="warning"
          description="Has anulado tu pago. Puedes volver a completar tus datos y reintentar. Recuerda tener a mano tu tarjeta."
          closer={null}
        />
      ) : (
        <Alert show bgType="info">
          <strong>Importante: </strong>
          En el siguiente paso te pediremos realizar tu primera inversión de cuotas de participación.
          <br />
          Ten a mano tu método de pago preferido.
        </Alert>
      )}

      <CardParticipationFees
        monthlyFees={monthlyFees}
        monthlyInvestment={monthlyInvestment}
        participationFeesParams={participationFeesParams}
        isValidMonthlyFee={isValidMonthlyFee}
        onChange={onChangeField}
        handleChangeCustom={handleChangeCustom}
        abono={abono}
      />
      <CardBankAccount
        bank={bank}
        accountType={accountType}
        accountNumber={accountNumber}
        banksItems={banksItems}
        accountsTypesItems={accountsTypesItems}
        onChange={onChangeField}
        disabled={!isCompletedCardParticipationFees}
      />
      <CardContracts
        contracts={contracts}
        isMobileDevice={isMobileDevice}
        onDownloadContract={onDownloadContract}
        disabled={!isCompletedCardBankAccount}
      />
      <CardStatutes
        isMobileDevice={isMobileDevice}
        onDownloadContract={onDownloadContract}
        disabled={!isCompletedCardBankAccount}
      />
      <CardTermsAndConditions
        termsAndConditions={termsAndConditions}
        onChange={onChangeField}
        disabled={!isCompletedCardBankAccount}
      />
      <CardEletronicSignature
        inputCodeSMS={inputCodeSMS}
        phone={phone}
        stateAuthSms={stateAuthSms}
        messagesInputAuthSms={messagesInputAuthSms}
        disabled={!isCompletedCardTermsAndConditions}
        isOpenModalEdgeCase={isOpenModalEdgeCase}
        closeModalEdgeCase={closeModalEdgeCase}
        onChange={onChangeField}
        onInvokeAuthSms={onInvokeAuthSms}
        onTimeOverToRespond={onTimeOverToRespond}
        validateSignature={validateSignature}
      />
      <FlowControlButtons
        nameButtonContinue="Ir al pago"
        canContinue={canContinueFlow}
        step="middle"
        onContinueFlow={onContinueFlow}
        onCancelFlow={onCancelFlow}
      />
      <Modal
        isOpen={isOpenModalEdgeCase}
        closeModal={closeModalEdgeCase}
        unableToClose={currentEdgeCase.blocker}
        closeClickOutside={!currentEdgeCase.blocker}
        closeEscKey={!currentEdgeCase.blocker}
      >
        {currentEdgeCase.title !== '' && isOpenModalEdgeCase && (
          <CaseInfo
            edgeCase={currentEdgeCase}
            isMobile={isMobileDevice}
            onClickButton={onActionButtonCaseBorder}
          />
        )}
      </Modal>
      <Modal isOpen={isOpenModalAbandonmentSurvey} closeModal={closeModalAbandonmentSurvey}>
        <Survey type="abandonment" onCloseModal={closeModalAbandonmentSurvey} />
      </Modal>
    </StyledWrapperCards>
  );
};

export default ContractsTemplate;
